import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Upload from './components/Upload';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/upload/:beratungsID" element={<Upload />} />
        {/* Add other routes here */}
      </Routes>
    </Router>
  );
};


export default App;